import React, { useEffect } from 'react';
import { UserAuth } from '../../utils/AuthContext';
import { Button, Tag } from '../PageSection/PageSection.styled'
import { Flex } from '../styles/Flex.styled';
// import { SectionContainer, ContentContainer, Button, Tag, ButtonFlex, Title, Subtitle, BackgroundImage } from "./PageSection.styled";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const Account = () => {
  const { logOut, user } = UserAuth();

  useEffect(() => {
    user.displayName !== undefined && 
      toast.success(`Welcome ${JSON.parse(localStorage.getItem('profile'))} name: ${user.displayName}. Thank you for registering in. We will inform you about the upcoming RaidLive event. Get Set Raid`, {
        position: toast.POSITION.TOP_RIGHT
      }); 
  },[user])

  const handleSignOut = async () => {
    try {
      if (user != null) {
        await logOut();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>      
    <ToastContainer/>
      <Tag style={{ fontSize: '2rem' }}>{JSON.parse(localStorage.getItem("profile")) && "welcome" }: {user.displayName}</Tag>
      <Flex><Button style={{ marginLeft: '.2em', padding: '10px 20px' }} onClick={handleSignOut}>
        Logout
      </Button></Flex>
    </>
  );
};

export default Account;